<template></template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import Authentication from "@/components/Authentication.vue";
import { mapState, mapMutations } from "vuex";
export default {
  name: "Logoff",
  data() {
    return {};
  },
  computed: {
    ...mapState("user", ["confirmed", "user", "state", "sn"])
  },
  async created() {
    await this.logout();
    this.$router.push("/");
  },
  methods: {
    ...mapMutations("user", [
      "emptyUser",
      "unsetConfirmed",
      "setState",
      "setSN",
      "setSNAnswer",
      "setError",
      "setLoading",
      "setAnswer",
      "setPhones"
    ]),
    async logout() {
      this.$Amplify.Auth.signOut();
      this.setSN(false);
      this.setSNAnswer(false);
      this.emptyUser();
      this.unsetConfirmed();
      this.setState("signedOut");
      this.setError(false);
      this.setLoading(false);
      this.setAnswer({});
      this.setPhones([]);
      this.$root.$emit("removeExtras");
    }
  }
};
</script>

<style lang="scss">
</style>
